/**
 * Shared constants for the mock exam grade guide (模擬試験の結果について).
 * Kept separate so badge, scale bar and card stay in sync.
 */
import { black, primary, text } from "@/theme/colors";
import { TMockExamGrade } from "@/infrastructure/adapters/mock-exam/mock-exam.types";

/**
 * Lower bound of every grade as a ratio of the passing score (合格基準 = 1), lowest grade first.
 * A grade spans from its own bound up to the next one — A has no bound above it, it runs to 満点.
 * Single source of truth for both the legend order and the scale bar widths.
 */
export const GRADE_LOWER_BOUND_RATIO: readonly { grade: TMockExamGrade; ratio: number }[] = [
  { grade: "E", ratio: 0 },
  { grade: "D", ratio: 0.5 },
  { grade: "C", ratio: 0.7 },
  { grade: "B", ratio: 0.9 },
  { grade: "A", ratio: 1 },
] as const;

/** Grades ordered from the highest (A) to the lowest (E), as shown in the legend list. */
export const MOCK_EXAM_GRADES: readonly TMockExamGrade[] = GRADE_LOWER_BOUND_RATIO.map(({ grade }) => grade).reverse();

/** Badge / scale-bar palette per grade. */
export const GRADE_COLORS: Record<TMockExamGrade, { bg: string; color: string }> = {
  A: { bg: primary[400], color: text.white },
  B: { bg: primary[500], color: text.white },
  C: { bg: primary[600], color: text.white },
  D: { bg: primary[700], color: text.primary },
  E: { bg: black[99], color: text.primary },
};
